import React, { memo, useEffect, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import { requestParamsImpl } from "../../services/request-params.service";
import { moduleSettings } from "../../stores/module-settings.store";
import { UrlParams } from "../../types";

interface IStyle {
  background: string;
}

const LinkButton = styled.a<IStyle>`
  position: absolute;
  line-height: 1;
  background: ${(props) => props.background};
  color: #fff;
  font-size: 16px;
  width: 180px;
  text-align: center;
  display: inline-block;
  padding: 10px;
  text-decoration: none;
  font-weight: bold;
  -moz-border-radius: 4px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  z-index: 9999;
  cursor: pointer;
`;

const Floating = () => {
  const { t, i18n } = useTranslation();
  const urlParams = useParams<UrlParams>();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const language = searchParams.get("language") || "fr";
  const [moduleInitialized, setModuleInitialized] = useState(false);
  const [buttonBackground, setButtonBackground] = useState("#20B8CF");
  const origin = window.location.origin;
  const link = `${origin}/instabook/bookings/v3/${urlParams.referralKey}/?cta=true`;

  requestParamsImpl.set(urlParams);
  useEffect(() => {
    moduleSettings.initModuleSettings().subscribe(() => {
      setModuleInitialized(true);
      setButtonBackground(moduleSettings.primaryColor);
    });
  }, []);

  useEffect(() => {
    i18n.changeLanguage(language);
  }, []);

  return (
    <>
      {moduleInitialized && (
        <LinkButton
          href={link}
          background={buttonBackground}
          className="open-module-button"
        >
          {t("floating_button.text")}
        </LinkButton>
      )}
    </>
  );
};

export const FloatingButton = memo(Floating);
